export default "//cloud.imgsmail.ru/cloud.mail.ru/153470/img/build/empty-state/feed_music.png";